import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../../firebase";
import { useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import { gymConfig } from "../../../config/gymConfig";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError("");
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/schedule", { replace: true });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Member Login"
      title={`Train, book, and track with ${gymConfig.brand.name}.`}
      description={`Sign in to ${gymConfig.brand.name} to manage classes, training progress, leaderboards, and your profile.`}
      footerPrompt="Need an account or membership first?"
      footerLabel="Join now"
      footerTo="/signup"
    >
      <form onSubmit={handleLogin} className="space-y-5">
        <div>
          <h2 className="text-2xl font-heading tracking-tight text-white">Welcome back</h2>
          <p className="mt-2 text-sm leading-6 text-[color:var(--color-text-subtle)]">
            Pick up where you left off, or create an account and start a membership if you're new.
          </p>
        </div>

        {error ? (
          <div className="app-status-danger rounded-2xl border px-4 py-3 text-sm">
            {error}
          </div>
        ) : null}

        <label className="block">
          <span className="mb-2 block text-sm font-medium text-[color:var(--color-text-muted)]">Email</span>
          <input
            type="email"
            placeholder="you@example.com"
            autoComplete="email"
            inputMode="email"
            className="app-input w-full rounded-2xl border px-4 py-3 text-white outline-none transition placeholder:text-[color:var(--color-text-subtle)] focus:bg-[color:var(--color-surface-overlay-strong)]"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="block">
          <span className="mb-2 block text-sm font-medium text-[color:var(--color-text-muted)]">Password</span>
          <input
            type="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            className="app-input w-full rounded-2xl border px-4 py-3 text-white outline-none transition placeholder:text-[color:var(--color-text-subtle)] focus:bg-[color:var(--color-surface-overlay-strong)]"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          className="app-button-primary w-full rounded-2xl px-4 py-3 font-semibold transition hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {loading ? "Signing in..." : "Log In"}
        </button>
      </form>
    </AuthShell>
  );
};

export default Login;
